<template>
  <div>
    <MainTitle title="专业工人" path="/worker" :titleImg="require('@/assets/fivef.png')"/>
    <div class="content">
      <div v-if="loading">
        <el-row :gutter="20">
          <el-col :span="12" :key="index" v-for="(item,index) in 6" style="">
            <el-skeleton style="width: 100%">
              <template slot="template">
                <div style="margin: 10px 5px;padding: 10px;border: 1px solid #e4e7ed">
                  <div style="display: flex">
                    <div>
                      <el-skeleton-item variant="image" style="width: 60px; height: 60px;" />
                    </div>
                    <div style="padding-left: 10px">
                      <el-skeleton-item variant="text" style="width: 200px" />
                      <div>
                        <el-skeleton-item variant="text" style="width: 150px" />
                      </div>
                    </div>
                  </div>
                  <el-skeleton-item variant="text" style="width: 150px" />
                  <el-skeleton-item variant="text" style="width: 150px" />
                  <hr style="border: dashed 1px #eee;margin: 5px 0">
                  <el-skeleton-item variant="text" style="width: 300px" />
                </div>
              </template>
            </el-skeleton>
          </el-col>
        </el-row>
      </div>
      <div >
        <el-row :gutter="20">
          <el-col :span="12" v-for="(item,index) in list" :key="index">
            <card :item="item" :type="3"></card>
          </el-col>
        </el-row>
        <paging :sq="this.param.page>1" :gd="list.length<this.param.total" @pageupdata="pageupdata"></paging>
      </div>
      <!-- 无数据 -->
      <BaseEmptyData v-if="!list.length && !loading"></BaseEmptyData>
    </div>
  </div>
</template>

<script>
import cookie from "@/storage/cookies"
import {apiWorker} from "@/api/apiWorker"

export default {
  name: "worker",
  components: {
    MainTitle: () => import("@/views/Home/AllComponents/MainTitle"), // 头部组件
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"), // 无数据组件
    paging: () => import("./paging"), // 分页组件
    card:()=>import("@/components/card/cardWorkerList.vue") // 专业工人card
  },
  data(){
    return {
      type:'0',
      list:[],
      param:{
        page: 1,
        limit: 6,
        total:0,
        sortType:1
      },
      code:{},
      loading:true
    }
  },
  created() {
    this.tabSelect({type:'0'});
  },
  methods:{
    pageupdata(v){
      if(v)this.param.page=v
      else this.param.page++;
      this.getlist();
    },
    tabSelect(v){
      this.type=v.type;
      //参数封装
      let code={}
      let cookieArea = cookie.cookieRead("area");
      let area = cookieArea ? JSON.parse(cookieArea) : null
      if(area)code.provinceNo = area.id
      this.func = apiWorker.teamInfoSearchList
      //参数重置
      this.code=code;
      this.param.page=1;
      this.getlist();
    },
    //获取数据列表
    async getlist(){
      if(this.param.page==1){
        this.list=[];
        this.param.total=0;
      }
      this.loading=true;
      let param={...this.param,...this.code}
      param.pageNum=param.page
      param.pageSize=param.limit

      let res=await this.func(param)
      if (res.data && res.data.code === 200){
        this.loading=false;
        if(this.param.page==1)this.list=res.data.data.records;
        else this.list=this.list.concat(res.data.data.records)
        this.param.total=res.data.data.total
      }
    },
    getList(){
      this.pageupdata(1)
      this.$emit('changeHash','box5')
    }
  },
  provide(){
    return {
      cardListCom:this
    }
  }
}
</script>

<style lang="scss" scoped>
  .content{
    width: 1200px;
    min-height: 200px;
    padding: 0 20px;
    background: #fff;
    box-sizing: border-box;
    margin: auto;
    /deep/.empty-data{
      padding: 0 0 20px;
    }
  }
</style>
